import { useState, useEffect } from 'react';
import axios from 'axios';

let cache = null;

export default function usePhysicalExists() {
  const [exists, setExists] = useState(cache ?? false);

  useEffect(() => {
    if (cache !== null) {
      setExists(cache);
      return;
    }
    axios.get('/api/physical-sales/exists')
      .then((res) => {
        cache = res.data.exists;
        setExists(cache);
      })
      .catch(() => {});
  }, []);

  return exists;
}
